// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/importance_level.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/schools/v1/resources/importance_level.proto.
 */
export const file_studyo_today_schools_v1_resources_importance_level = /*@__PURE__*/
  fileDesc("CjhzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvaW1wb3J0YW5jZV9sZXZlbC5wcm90bxIhc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEucmVzb3VyY2VzKqsBCg9JbXBvcnRhbmNlTGV2ZWwSIAocSU1QT1JUQU5DRV9MRVZFTF9VTlNQRUNJRklFRBAAEh0KGUlNUE9SVEFOQ0VfTEVWRUxfUkVNSU5ERVIQARIcChhJTVBPUlRBTkNFX0xFVkVMX1JFR1VMQVIQAhIaChZJTVBPUlRBTkNFX0xFVkVMX01BSk9SEAMSHQoZSU1QT1JUQU5DRV9MRVZFTF9DUklUSUNBTBAEQimqAiZTdHVkeW8uVG9kYXkuU2Nob29scy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.schools.v1.resources.ImportanceLevel.
 */
export const ImportanceLevelSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_schools_v1_resources_importance_level, 0);

/**
 * Levels of importance, which can be applied to work.
 *
 * @generated from enum studyo.today.schools.v1.resources.ImportanceLevel
 */
export const ImportanceLevel = /*@__PURE__*/
  tsEnum(ImportanceLevelSchema);

